"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowOutputStepSelector = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var react_1 = __importDefault(require("react"));
var reselect_1 = require("reselect");
var Localize_1 = require("../../../gen-src/Localize");
function createListItems(outputSteps) {
    return outputSteps.map(function (outputStep) {
        return {
            value: outputStep.id,
            content: outputStep.name || Localize_1.Messages.PermissionsRequired(),
            tooltip: outputStep.name || Localize_1.Messages.PermissionsRequired()
        };
    });
}
var FlowOutputStepSelector = /** @class */ (function (_super) {
    __extends(FlowOutputStepSelector, _super);
    function FlowOutputStepSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.memoizedListItems = (0, reselect_1.defaultMemoize)(createListItems);
        return _this;
    }
    FlowOutputStepSelector.prototype.getSelectedOutputStepName = function () {
        var _this = this;
        var selectedOutputStep = this.props.outputSteps.find(function (os) { return os.id === _this.props.selectedOutputStep; });
        return selectedOutputStep && selectedOutputStep.name ? selectedOutputStep.name : Localize_1.Messages.PermissionsRequired();
    };
    FlowOutputStepSelector.prototype.render = function () {
        var listItems = this.memoizedListItems(this.props.outputSteps);
        var outputStepName = this.getSelectedOutputStepName();
        return (react_1.default.createElement(widgets_1.SingleSelectDropdown, { label: '', list: react_1.default.createElement(widgets_1.List, { items: listItems, selectedValue: this.props.selectedOutputStep }), type: widgets_1.DropdownButtonType.Outline, value: this.props.selectedOutputStep, onChange: this.props.updateOutputStepSelection, style: data_catalog_shared_1.dropdownStyle },
            react_1.default.createElement(data_catalog_shared_1.DropdownSelectedItem, { title: outputStepName }, outputStepName)));
    };
    return FlowOutputStepSelector;
}(react_1.default.PureComponent));
exports.FlowOutputStepSelector = FlowOutputStepSelector;
//# sourceMappingURL=FlowOutputStepSelector.js.map